<!-- bbs > 활동이력 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="tit-group ty01 mo-home-add">
        <BtnIcon class="btn-ico-home" @click="utils.movePage('/actionManagement')"></BtnIcon>
        <h4 class="tit">{{monitoringInfo.monitoringTitle}}</h4>
      </div>
      <div class="tab-group ty01">
        <v-tabs
          v-model="tab"
        >
          <v-tab value="tabCont1">{{t('message.currentMonitoring')}}</v-tab>
          <v-tab value="tabCont2">{{t('message.allMonitoring')}}</v-tab>
          <v-tab value="tabCont3">{{t('message.departmentMonitoring')}}</v-tab>
        </v-tabs>
      </div>
      <div class="content-box bg-none">
        <v-tabs-window v-model="tab">
          <v-tabs-window-item value="tabCont1">
            <monitoring-tab-cont3-table :monitoringType="1" :key="tabKey" :is-active="tab === 'tabCont1'"/>
          </v-tabs-window-item>
          <v-tabs-window-item value="tabCont2">
            <monitoring-tab-cont3-table :monitoringType="2" :key="tabKey" :is-active="tab === 'tabCont2'"/>
          </v-tabs-window-item>
          <v-tabs-window-item value="tabCont3">
            <monitoring-tab-cont3-table :monitoringType="3" :key="tabKey" :is-active="tab === 'tabCont3'"/>
          </v-tabs-window-item>
        </v-tabs-window>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const route:any = useRoute()

//define
const props = defineProps({isActive: Boolean})

//bind
const snackbar = ref(false)
const snackText = ref('')
const tab = ref('tabCont1')
const monitoringInfo:any = ref({})
let viewIdx = route.params.idx

//computed
const tabKey = computed(() => `${tab.value}-${Date.now()}`)

//hook
onMounted(()=>{
})

watch(() => props.isActive, (val, oldVal) => {
  if (viewIdx) {
    //모니터링정보
    BbsService.getBbsMonitoring({idx: viewIdx}).then(
      (response) => {
        //모니터링
        monitoringInfo.value = response.result
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
},{ immediate: true })
</script>


<style lang="scss" scoped>
.container.main.on{
  .v-window{}
}
</style>

